"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _formConverters = _interopRequireDefault(require("./formConverters"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var convertPercentWithSign = _formConverters.default.out.convertPercentWithSign;
var _default = {
  monthlyInterest: function monthlyInterest(annualInterest) {
    return annualInterest * 0.01 / 12;
  },
  // This log forumla is also in C# App.Core.Common.Math.Formulas.cs
  estimatedPayoutTerm: function estimatedPayoutTerm(rate, balance, payment) {
    var cleanRate = convertPercentWithSign(rate);

    if ((0, _isEqual.default)(Number(cleanRate), 0)) {
      return Math.ceil(balance / payment);
    }

    var monthlyRate = this.monthlyInterest(cleanRate);
    var monthlyNumerator = monthlyRate * balance;
    var logBase = 1 + monthlyRate;
    var logValue = 1 - monthlyNumerator / payment;
    var estimatedTerm = Math.ceil(-1 * (Math.log(logValue) / Math.log(logBase)));
    return !isNaN(estimatedTerm) && isFinite(estimatedTerm) ? estimatedTerm : null;
  },
  estimatedMonthlyPayment: function estimatedMonthlyPayment(rate, balance, term) {
    var cleanRate = convertPercentWithSign(rate);
    var monthlyRate = this.monthlyInterest(cleanRate);
    var monthlyNumerator = monthlyRate * balance;
    var monthlyDenominator = 1 - Math.pow(1 + monthlyRate, -1 * term);
    return monthlyNumerator / monthlyDenominator;
  }
};
exports.default = _default;